export default __webpack_public_path__ + "static/media/mona-wassermann-logo-vit.42751b5c.png";